import { useCallback } from "react"

const AUTH_STATE_KEY = "auth_state"
const STATE_EXPIRY_KEY = "auth_state_expiry"
const STATE_TTL = 5 * 60 * 1000

function useAuthState() {
    const generateState = useCallback(() => {
        const state = crypto.randomUUID()
        const expiryTime = Date.now() + STATE_TTL

        sessionStorage.setItem(AUTH_STATE_KEY, state)
        sessionStorage.setItem(STATE_EXPIRY_KEY, expiryTime.toString())

        return state
    }, [])

    const verifyState = useCallback((returnedState: string | null): boolean => {
        if (!returnedState) return false

        const savedState = sessionStorage.getItem(AUTH_STATE_KEY)
        const expiryTime = parseInt(sessionStorage.getItem(STATE_EXPIRY_KEY) ?? "0")

        sessionStorage.removeItem(AUTH_STATE_KEY)
        sessionStorage.removeItem(STATE_EXPIRY_KEY)

        return savedState === returnedState && Date.now() < expiryTime
    }, [])

    const clearState = useCallback(() => {
        sessionStorage.removeItem(AUTH_STATE_KEY)
        sessionStorage.removeItem(STATE_EXPIRY_KEY)
    }, [])

    return { generateState, verifyState, clearState }
}

export default useAuthState